import { getField, updateField } from 'vuex-map-fields'
import api from '@/lib/api'
import { IN_PROGRESS, COMPLETE, ERROR } from '@/lib/constants/actionStatuses'
import { PATH_THIRD_PARTY_PORTALS } from '@/lib/constants/api'
import updateStatus from '@/store/helpers/updateStatus'
import { notifyError } from '@/lib/notifications'
import buildInitialState from '@/store/helpers/buildInitialState'
import { hideProgressModal, showProgressModal } from '@/lib/progressModal'

const thirdPartyPortals = {
  namespaced: true,
  state: buildInitialState({
    thirdPartyPortalsList: []
  }),
  getters: {
    getField
  },
  mutations: {
    updateField,
    updateStatus,
    setThirdPartyPortalsList: (state, thirdPartyPortalsList) => {
      state.thirdPartyPortalsList = thirdPartyPortalsList
    }
  },
  actions: {
    getThirdPartyPortalsList: ({ commit, dispatch }) => {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Getting third party portals, Please wait...' })

      return api.doGet({ path: PATH_THIRD_PARTY_PORTALS })
        .then(json => json.data)
        .then(thirdPartyPortalsList => {
          commit('updateStatus', { status: COMPLETE })
          commit('setThirdPartyPortalsList', thirdPartyPortalsList)
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          notifyError(dispatch, 'Unable to select third party portals')
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    }
  }
}

export default thirdPartyPortals
